import { Grid, Typography, withStyles } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { GuestType } from "../../store/types/userTypes";
import CheckBoxOption from "./CheckBoxOption";

type CardItemAuthorizationProps = {
  id: string;
  checkValue: boolean;
  tabIndex?: number;
  checkHandle: (checked: boolean, id: string, guestType: GuestType) => void;
  children?: React.ReactNode;
  toggleTypeValue: GuestType;
  toggleTypeHandle: (value: any, id: string) => void;
  hiddenProvider?: boolean;
};

export const CardItemAuthorization = ({
  id,
  checkValue,
  tabIndex,
  checkHandle,
  children,
  toggleTypeValue,
  toggleTypeHandle,
  hiddenProvider,
}: CardItemAuthorizationProps) => {
  const { t, BundleKey } = useTranslation();
  const StyledToggleButtonGroup = withStyles((theme) => ({
    grouped: {
      margin: theme.spacing(0.5),
      border: "none",

      "&:not(:first-child)": {
        // border: 'none',
        borderRadius: theme.shape.borderRadius,
      },
      "&:first-child": {
        // border: '1px solid ' + theme.palette.primary.main,
        borderRadius: theme.shape.borderRadius,
      },
      "&.Mui-selected": {
        backgroundColor: "transparent",
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },
  }))(ToggleButtonGroup);

  const handleCheckedWithId = (_event: any, checked: boolean) => {
    checkHandle(checked, id, toggleTypeValue);
  };

  const handleToggleWithId = (_event: any, value: any) => {
    if (value) toggleTypeHandle(value, id);
  };

  return (
    <Grid item>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={2} sm={1}>
          <CheckBoxOption
            checked={checkValue}
            tabIndex={tabIndex}
            onChange={handleCheckedWithId}
            color="primary"
          />
        </Grid>
        <Grid item xs={10} sm={8}>
          <Typography variant="subtitle2">{children}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <StyledToggleButtonGroup
            value={toggleTypeValue}
            exclusive
            size="small"
            onChange={handleToggleWithId}
            aria-label="text alignment"
          >
            <ToggleButton
              value={GuestType.any}
              aria-label="left aligned"
              tabIndex={tabIndex}
            >
              <Typography variant="subtitle2" color="primary">
                {t(BundleKey.DETAIL_AUTHORIZATION_PARTICULAR)}
              </Typography>
            </ToggleButton>
            {!hiddenProvider ? (
              <ToggleButton
                value={GuestType.provider}
                aria-label="centered"
                tabIndex={tabIndex}
              >
                <Typography variant="subtitle2" color="primary">
                  {t(BundleKey.DETAIL_AUTHORIZATION_PROVIDER)}
                </Typography>
              </ToggleButton>
            ) : null}
          </StyledToggleButtonGroup>
        </Grid>
      </Grid>
    </Grid>
  );
};
